import { render, staticRenderFns } from "./EstadoCuenta.vue?vue&type=template&id=68915cf2&scoped=true&"
import script from "./EstadoCuenta.vue?vue&type=script&lang=js&"
export * from "./EstadoCuenta.vue?vue&type=script&lang=js&"
import style0 from "./../transit/transit-list.css?vue&type=style&index=0&id=68915cf2&scoped=true&lang=css&"
import style1 from "./EstadoCuenta.vue?vue&type=style&index=1&id=68915cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68915cf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDialog,VDivider,VFlex,VIcon,VLayout,VPagination,VSnackbar,VTooltip})
